import { PRACTICAL_STREAM_CDN_ADDRESS, USE_CDN } from '../utilities/config'
import { HOST } from '../../pages/api/utils/config'

export const SPOTIFY_ISNT_LEGAL_ARTICLE_TITLE: string =
  'Spotify Isn’t Legal for Your Business — Here’s What to Do Instead'
export const SPOTIFY_ISNT_LEGAL_ARTICLE_TITLE_ES: string =
  'Spotify no es Legal para su Negocio: Esto es lo que Debe Hacer en su Lugar'
export const SPOTIFY_ISNT_LEGAL_ARTICLE_TITLE_FR: string =
  "Spotify n'est pas Légal pour Votre Entreprise : Voici ce que vous Devriez Faire à la Place"
export const SPOTIFY_ISNT_LEGAL_ARTICLE_TITLE_KO: string =
  'Spotify는 귀하의 비즈니스에 합법적이지 않습니다. 대신 해야 할 일은 다음과 같습니다.'

export const SPOTIFY_ISNT_LEGAL_TITLE_HTML: JSX.Element = (
  <>
    Spotify Isn’t Legal for Your Business&nbsp;—
    <br />
    Here’s What to Do Instead
  </>
)
export const SPOTIFY_ISNT_LEGAL_TITLE_HTML_ES: JSX.Element = (
  <>
    Spotify no es legal para su megocio:
    <br />
    esto es lo que debe hacer en su lugar
  </>
)
export const SPOTIFY_ISNT_LEGAL_TITLE_HTML_FR: JSX.Element = (
  <>
    Spotify n'est pas légal pour votre entreprise&nbsp;:
    <br />
    voici ce que vous devriez faire à la place
  </>
)
export const SPOTIFY_ISNT_LEGAL_TITLE_HTML_KO: JSX.Element = (
  <>
    <span aria-hidden={true} className={'atb'}>
      Spotify는
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      귀하의
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      비즈니스에
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      합법적이지
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      않습니다.
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      대신
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      해야
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      할
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      일은
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      다음과
    </span>{' '}
    <span aria-hidden={true} className={'atb'}>
      같습니다.
    </span>
  </>
)

export const SPOTIFY_ISNT_LEGAL_PAGE_ID: string =
  '689C32CF-8397-44BE-99F0-7240A0671B23'

export const SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE: string =
  '/articles/spotify-isnt-legal-for-your-business'
export const SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_ES: string =
  '/articles/spotify-isnt-legal-for-your-business'
export const SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_FR: string =
  '/articles/spotify-isnt-legal-for-your-business'
export const SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_KO: string =
  '/articles/spotify-isnt-legal-for-your-business'

export const SPOTIFY_ISNT_LEGAL_ARTICLE_URL: string =
  HOST + SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_ES
export const SPOTIFY_ISNT_LEGAL_ARTICLE_URL_ES: string =
  HOST + '/es' + SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_ES
export const SPOTIFY_ISNT_LEGAL_ARTICLE_URL_FR: string =
  HOST + '/fr' + SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_FR
export const SPOTIFY_ISNT_LEGAL_ARTICLE_URL_KO: string =
  HOST + '/ko' + SPOTIFY_ISNT_LEGAL_ARTICLE_ROUTE_KO

export const ARTICLE_KEYWORDS =
  'spotify, legal, music stream, background music streaming, business background music, ambient music, licensed music, music for restaurants, music for retail, practical stream'
export const ARTICLE_KEYWORDS_ES =
  'spotify, legal, transmisión de música, transmisión de música de fondo, música de fondo profesional, música de fondo, música con licencia, música para restaurantes, música para venta minorista, practical stream'
export const ARTICLE_KEYWORDS_FR =
  "spotify, légal, flux de musique, musique de fond en streaming, musique de fond professionnelle, musique d'ambiance, musique sous licence, musique pour restaurants, musique pour la vente au détail, practical stream"
export const ARTICLE_KEYWORDS_KO =
  'spotify, 법률, 음악 스트리밍, 배경 음악 스트리밍, 전문 배경 음악, 배경 음악, 라이선스 음악, 레스토랑 음악, 소매 음악, practical stream'

export const ARTICLE_IMAGE_AVIF: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '10F38EAF-3B7B-4A7A-9F86-2706385EDBFC.avif'
  : HOST + '/images/10F38EAF-3B7B-4A7A-9F86-2706385EDBFC.avif'
export const ARTICLE_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '10F38EAF-3B7B-4A7A-9F86-2706385EDBFC.jpg'
  : HOST + '/images/10F38EAF-3B7B-4A7A-9F86-2706385EDBFC.jpg'
export const OPEN_GRAPH_IMAGE_JPEG: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + '7F2DBA71-DD5C-4F6B-A456-E18B43BFA2F9.jpg'
  : HOST + '/images/7F2DBA71-DD5C-4F6B-A456-E18B43BFA2F9.jpg'

export const SPOTIFY_ISNT_LEGAL_JSON_LD_IMAGE_1200_X_1200: string = USE_CDN
  ? PRACTICAL_STREAM_CDN_ADDRESS + 'B027DFC0-B209-45F2-ADAD-2B860D6B3DA5.png'
  : HOST + '/images/B027DFC0-B209-45F2-ADAD-2B860D6B3DA5.png'

export const ARTICLE_SUMMARY: string =
  'A Spotify business license doesn’t exist. Proper business music streaming rights protect your business. Stop using consumer streaming today. Go for legal, licensed platforms.'
export const ARTICLE_SUMMARY_ES: string =
  'No existe una licencia de Spotify Business. Los derechos de transmisión de música comerciales adecuados protegen su negocio. Deje de utilizar la transmisión por secuencias para consumidores hoy. Elija una plataforma legal y con licencia.'
export const ARTICLE_SUMMARY_FR: string =
  "Il n'y a pas de licence Spotify Business. Les bons droits de diffusion de musique commerciale protègent votre entreprise. Arrêtez d’utiliser le streaming grand public dès aujourd’hui. Choisissez une plateforme légale et sous licence."
export const ARTICLE_SUMMARY_KO: string =
  'Spotify 비즈니스 라이선스가 존재하지 않습니다. 적절한 비즈니스 음악 스트리밍 권리는 귀하의 비즈니스를 보호합니다. 오늘부터 소비자 스트리밍 사용을 중단하세요. 합법적이고 라이센스가 있는 플랫폼을 선택하세요.'

export const SPOTIFY_ISNT_LEGAL_ARTICLE_PUBLISHED_STR: string = '2025-12-01'
export const SPOTIFY_ISNT_LEGAL_ARTICLE_CREATED_STR: string = '2025-12-01'
export const SPOTIFY_ISNT_LEGAL_ARTICLE_PUBLISHED: Date = new Date(
  SPOTIFY_ISNT_LEGAL_ARTICLE_PUBLISHED_STR
)
export const SPOTIFY_ISNT_LEGAL_ARTICLE_CREATED: Date = new Date(
  SPOTIFY_ISNT_LEGAL_ARTICLE_CREATED_STR
)
